"use client";

import { clsx } from "@trydig/ui";
import { Skeleton } from "~/components/ui/Skeleton";
import { ProductGrid } from "~/features/products/ProductGrid";
import { PaginationFallback } from "~/features/products/ProductListingPage/components/Pagination/Pagination";
import styles from "./ProductListingPage.module.css";

export const PaginationSectionFallback = () => (
	<section data-layout="page">
		<PaginationFallback />
	</section>
);

export const ProductCardSkeleton = () => (
	<div className={styles.card__skeleton}>
		<div className={styles.card__image} />
		<Skeleton height={"24px"} />
		<Skeleton height={"16px"} />
		{/* needs one more of these on yarn PLP */}
		<Skeleton height={"24px"} />
	</div>
);

export const ProductGridSkeleton = () => (
	<section data-layout="page" className={styles["main-content"]}>
		<div className={styles.filter_modal_skeleton} />
		<div className={styles.products__wrapper}>
			<ProductGrid>
				{[...Array(6)].map((_, i) => (
					<ProductCardSkeleton key={`skeleton-card--${i}`} />
				))}
			</ProductGrid>
		</div>
	</section>
);

export const FilterBarSkeleton = () => (
	<section data-layout="page" style={{ marginBottom: 16 }}>
		<div className={clsx(styles["filters-nav"], styles.filters__skeletons)}>
			<Skeleton height={"31px"} />
			<Skeleton height={"31px"} />
			<Skeleton height={"31px"} />
		</div>
	</section>
);

export const ProductListingPageSkeleton = () => {
	return (
		<>
			<FilterBarSkeleton />
			<ProductGridSkeleton />
			<PaginationSectionFallback />
		</>
	);
};
